import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { PRIORITY_TASKS_QUERY } from '../graphql/queries'
import { FETCH_PRIORITY_TASKS } from '../redux/action-types'
import { cleanupFetchPriorityTasks } from '../redux/actions'

const usePriorityTasksQuery = ({ pageSize, currentPage } = {}) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchPriorityTasks)

  const { isLoading, error, data } = useSelector(
    store => store.priorityTasks.priorityTasks,
  )

  const refetch = useCallback(
    paginationParam =>
      apolloService.query({
        query: PRIORITY_TASKS_QUERY,
        variables: {
          pagination: paginationParam,
        },
        dispatch,
        action: FETCH_PRIORITY_TASKS,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch({ pageSize, currentPage })
  }, [refetch, pageSize, currentPage])

  return { isLoading, error, data, refetch }
}

export default usePriorityTasksQuery
